<i18n>
  {
    "fr": {
      "title": "Escales",
      "direct": "Direct",
      "one-stopover": "Une escale ou moins",
      "many-stopover": "Indifférent"
    },
    "en": {
      "title": "Stops",
      "direct": "No stops",
      "one-stopover": "One stop or less",
      "many-stopover": "Any number of stops"
    }
  }
</i18n>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    min-width="360px"
  >
    <template #activator="{on, attrs, value}">
      <v-btn
        v-bind="attrs"
        depressed
        :color="isDefaultValue ? 'white' : 'primaryLight'"
        :class="{'filter-not-default-state': !isDefaultValue}"
        class="pr-2"
        v-on="on"
      >
        {{ $t('title') }}
        <v-icon
          v-if="value === true"
          color="primary"
        >
          mdi-menu-up
        </v-icon>
        <v-icon
          v-else-if="value === false"
          color="primary"
        >
          mdi-menu-down
        </v-icon>
      </v-btn>
    </template>

    <v-card flat>
      <v-card-title
        class="py-0"
      >
        <v-col>
          {{ $t('title') }}
        </v-col>
        <v-spacer />
        <v-btn
          icon
          @click="menu = false"
        >
          <v-icon color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-radio-group
          v-model="selectedStopover"
        >
          <v-radio
            v-for="(choice, index) in stopoverChoices"
            :key="'stopoverChoice' + index"
            :label="$t(choice.name)"
            :value="choice.value"
            color="primary"
          />
        </v-radio-group>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import _ from 'lodash'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'FlightFilterStopover',
  data: () => ({
    menu: false
  }),
  computed: {
    ...mapState({
      selectedStopoverState: state => state.fb.searchFilters.selectedStopover,
      stopoverOptions: state => state.fb.searchFilters.stopover
    }),
    selectedStopover: {
      /**
       * Return vueX store state
       * @return {string}
       */
      get () {
        return this.selectedStopoverState
      },
      /**
       * Set new vueX store state
       * @param newVal {string}
       */
      set (newVal) {
        this.changeSelectedStopover(newVal)
      }
    },
    /**
     * Return vueX store state
     * @return {[{name: string, value: string}, {name: string, value: string}, {name: string, value: string}]}
     */
    stopoverChoices () {
      return this.stopoverOptions
    },
    /**
     * Check if selected stopover is at default value
     * @return {boolean}
     */
    isDefaultValue () {
      return this.selectedStopover === 'manystopover'
    }
  },
  created () {
    this.changeSelectedStopover = _.debounce(this.changeSelectedStopover, 600)
  },
  methods: {
    ...mapMutations({
      changeSelectedStopover: 'fb/searchFilters/setSelectedStopover'
    })
  }
}
</script>

<style scoped>
  .filter-not-default-state {
    color: #003d58;
  }
</style>
